import React from 'react';
import { NumberField } from '../../../../common/NumberField';

/**
 * Minimal wrapper over a number field to build an attachment meta-information component.
 *
 * @param id used for the id, testId and name of the NumberField
 * @param label label of the numerical field
 * @param form hosting form
 * @param required
 * @param readOnly
 * @param className
 * @param validations react-hook-form format validations
 *  E.g.:
 *    const documentTypeValidation = fieldName => ({
 *     validate: {
 *       all: all(),
 *       required: required(fieldName),
 *       string: text(1, 128),
 *     },
 *   });
 * @returns {JSX.Element}
 * @constructor
 */
const AttachmentMetaNumber = ({ id, label, form, required, readOnly, className, validations }) => {
  const { errors, register, clearErrors } = form;

  return (
    <NumberField
      required={required}
      className={className}
      id={id}
      testId={id}
      name={id}
      label={label}
      readOnly={readOnly}
      errors={errors}
      register={register}
      validations={validations}
      onChange={() => {
        // Clear any existing error for the field after making an update
        // Field validation shall be triggered after clicking Upload File only
        if (errors?.[id]) clearErrors(id);
      }}
      type="number"
      maxValue={999999}
    />
  );
};

export default AttachmentMetaNumber;
